import React, { useEffect, useRef, useState } from 'react';

import { ArMarkerControls } from '@hatsumatsu/ar.js/three.js/build/ar-threex.js';

import { useFrame } from '@react-three/fiber';
import { useAR } from './ar';

const ARMarker = ({
    children,
    type = 'barcode',
    barcodeValue = 0,
    patternUrl,
    // changeMatrixMode = 'cameraTransformMatrix',
    params,
    onMarkerFound = () => {},
    onMarkerLost = () => {},
}) => {
    const markerRoot = useRef();
    const arToolkitContext = useAR();
    const isFound = useRef(false);

    useEffect(() => {
        if (!arToolkitContext) {
            return;
        }

        console.log('arMarker()', 'add MarkerControls');

        const markerControls = new ArMarkerControls(arToolkitContext, markerRoot.current, {
            type,
            barcodeValue: type === 'barcode' ? barcodeValue : null,
            patternUrl: type === 'pattern' ? patternUrl : null,
            // changeMatrixMode: changeMatrixMode,
            smooth: true,
            ...params,
        });

        return () => {};
    }, [arToolkitContext, type, barcodeValue, patternUrl, params]);

    useFrame(() => {
        if (!markerRoot.current) {
            return;
        }

        // added a check to only find markers in the center of the scene
        if (
            markerRoot.current.visible &&
            markerRoot.current.position.x > -3 &&
            markerRoot.current.position.x < 3 &&
            !isFound.current
        ) {
            isFound.current = true;
            onMarkerFound();
        } else if (
            (!markerRoot.current.visible || markerRoot.current.position.x < -3 || markerRoot.current.position.x > 3) &&
            isFound.current
        ) {
            isFound.current = false;
            onMarkerLost();
        }
    });

    return <group ref={markerRoot}>{children}</group>;
};

export default ARMarker;
